export const MuiList = {
  padding: {
    paddingBottom: 0,
    paddingTop: 0,
  },
};
